import { decodeJWT } from "@/lib/utils";

const SESSION_KEY = "order_portal_session";

export function getSession(): Session | null {
  try {
    const stored = localStorage.getItem(SESSION_KEY);
    if (!stored) {
      return null;
    }

    const session = JSON.parse(stored) as Session;

    const decodedToken = decodeJWT(session.token);
    if (!decodedToken) {
      clearSession();
      return null;
    }

    // Check if session has expired
    const now = Math.floor(Date.now() / 1000); // Current time in seconds
    if (now >= decodedToken.exp) {
      clearSession();
      return null;
    }

    return session;
  } catch (error) {
    console.error("Failed to retrieve session:", error);
    clearSession();
    return null;
  }
}

/**
 * Saves session data to localStorage
 */
export function setSession(session: Session): void {
  try {
    localStorage.setItem(SESSION_KEY, JSON.stringify(session));
  } catch (error) {
    console.error("Failed to set session:", error);
  }
}

/**
 * Clears session data from localStorage
 */
export function clearSession(): void {
  try {
    localStorage.removeItem(SESSION_KEY);
  } catch (error) {
    console.error("Failed to clear session:", error);
  }
}

/**
 * Check if user is authenticated
 */
export function isAuthenticated(): boolean {
  return getSession() !== null;
}
